import { render, staticRenderFns } from "./ImageWithDnD.vue?vue&type=template&id=032de132&scoped=true&"
import script from "./ImageWithDnD.vue?vue&type=script&lang=ts&"
export * from "./ImageWithDnD.vue?vue&type=script&lang=ts&"
import style0 from "./ImageWithDnD.vue?vue&type=style&index=0&id=032de132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032de132",
  null
  
)

export default component.exports